import {useState} from "react";
import {useLocation, useOutletContext, useParams} from "react-router-dom";

import {useNavigateWithReload} from "base/hooks";
import EditIcon from "@mui/icons-material/Edit";
import {DepositoForm} from "../presentational/form";
import {SectionCardHeaderAction} from "base/component/presentational";
import {DepositoService} from "abastecemento/service";
import {deposito_view_adapter} from "abastecemento/model";
import {DepositoLocationSection} from "../presentational/section";
import {SisbagalSectionCard} from "sisbagal/auth";

const UpdateDepositoGeoPanel = () => {
    const {section} = useParams();
    const location = useLocation();
    const baseLocationPath = location.pathname.split(section)[0];

    const [mode, setMode] = useState("view");
    const [error, setError] = useState("");
    const navigate = useNavigateWithReload();

    let deposito;
    [deposito] = useOutletContext();

    const handleSubmit = deposito => {
        DepositoService.update(deposito_view_adapter({...deposito}))
            .then(() => {
                navigate(location.pathname, true);
            })
            .catch(error => {
                setError(error);
            });
    };

    const handleFormCancel = () => {
        setMode("view");
    };

    const secondaryActions = [
        <SectionCardHeaderAction
            key="edit"
            name="edit"
            text="Modificar"
            icon={<EditIcon />}
            onClick={() => {
                setMode("edit");
            }}
            roles={[]}
        />,
    ];

    return (
        <SisbagalSectionCard title="Ubicación" secondaryActions={secondaryActions}>
            {mode === "edit" ? (
                <DepositoForm
                    deposito={deposito}
                    updatedSection="geo"
                    onSubmit={handleSubmit}
                    onCancel={handleFormCancel}
                />
            ) : (
                <DepositoLocationSection deposito={deposito} />
            )}
        </SisbagalSectionCard>
    );
};

export default UpdateDepositoGeoPanel;
